//For QA
// export const API_URL = "http://qa.power-recruit.net";

export const USA_VENDORS = ["Beeline", "Vectorvms", "Dotstaff", "Covendis", "Ariba", "Simplify"];
/* Commenting the following code for POW-820.Dharma using AI Agent. Jun 04, 2026. Comment Start */
// export const CAN_VENDORS = ["FieldGlass"];
/* Commenting end. Dharma using AI Agent. Jun 04, 2026 */
/* Commenting the following code for POW-821.Dharma using AI Agent. Jun 05, 2026. Comment Start */
// export const CAN_VENDORS = ["FieldGlass", "CityOfWinnipeg"];
/* Commenting end. Dharma using AI Agent. Jun 05, 2026 */
/* Added the following code for POW-821.Dharma using AI Agent. Jun 05, 2026. Code Start */
export const CAN_VENDORS = ["FieldGlass", "CityOfWinnipeg", "AlbertaInnovates"];
/* Code end. Dharma using AI Agent. Jun 05, 2026 */
//For Production
export const API_URL = "https://app.powerrecruit.net";
/* Added the following code for POW-NOTIFY.Istiyak using AI Agent. April 5, 2026. Code Start */
/* Commenting the following code for Istiyak using AI Agent. April 8, 2026. Comment Start */
/** Unauthenticated REST: list notifications (latest first). Native WebSocket STOMP: `ws(s)://<same host>/ws`, topic `/topic/notifications`. */
/* Commenting end. Istiyak using AI Agent. April 8, 2026 */
/* Added the following code for Istiyak using AI Agent. April 8, 2026. Code Start */
/** User-specific REST list endpoint; STOMP WebSocket subscribes to `/user/queue/notifications`. */
/* Code end. Istiyak using AI Agent. April 8, 2026 */
export const NOTIFICATIONS_LIST_URL = API_URL + "/notifications";

export const NOTIFICATIONS_WS_URL = "";

/* Added the following code for Istiyak using AI Agent. April 8, 2026. Code Start */
export const NOTIFICATIONS_MARK_ONE_READ_URL = NOTIFICATIONS_LIST_URL + "/{notificationsId}/read";
export const NOTIFICATIONS_MARK_ALL_READ_URL = NOTIFICATIONS_LIST_URL + "/read-all";
export const NOTIFICATIONS_DELETE_ONE_URL = NOTIFICATIONS_LIST_URL + "/{notificationsId}";
export const NOTIFICATIONS_DELETE_ALL_URL = NOTIFICATIONS_LIST_URL;
/* Code end. Istiyak using AI Agent. April 8, 2026 */
/* Code end. Istiyak using AI Agent. April 5, 2026 */

export const VMSExpenseAPI= API_URL + "/api/job/getVendorpercentage"
export const ClientFeeAPI= API_URL +  "/api/job/getClientFee"

/* Added the following code for Istiyak using AI Agent. August 21, 2026. Code Start */
/**
 * Silent recruiter activity log. Backend: POST /api/job/track/recruiter with RecruiterLogRequest body.
 * action values must match RecruiterAction enum names exactly.
 */
export const TRACK_RECRUITER_URL = API_URL + "/api/job/track/recruiter";
export const RECRUITER_ACTIONS = {
	LOGIN: "LOGIN",
	VIEW_EXPLANATION: "VIEW_EXPLANATION",
	/* Added the following code for Istiyak using AI Agent. August 25, 2026. Code Start */
	SUBMIT_IMMEDIATELY: "SUBMIT_IMMEDIATELY",
	/* Code end. Istiyak using AI Agent. August 25, 2026 */
	NAVIGATED_TO_DASHBOARD: "NAVIGATED_TO_DASHBOARD",
	NAVIGATED_TO_AUTOMATION_DASHBOARD: "NAVIGATED_TO_AUTOMATION_DASHBOARD",
	NAVIGATED_TO_UPLOAD_JOBS: "NAVIGATED_TO_UPLOAD_JOBS",
	NAVIGATED_TO_MANAGE_JOBS: "NAVIGATED_TO_MANAGE_JOBS",
	NAVIGATED_TO_RESUME_JOB_MATCH: "NAVIGATED_TO_RESUME_JOB_MATCH",
	NAVIGATED_TO_MANAGE_CANDIDATES: "NAVIGATED_TO_MANAGE_CANDIDATES",
	NAVIGATED_TO_MANAGE_CONSULTANTS: "NAVIGATED_TO_MANAGE_CONSULTANTS",
	NAVIGATED_TO_MATCH_HISTORY: "NAVIGATED_TO_MATCH_HISTORY",
	NAVIGATED_TO_JOB_RESUME_MATCH_HISTORY: "NAVIGATED_TO_JOB_RESUME_MATCH_HISTORY",
	NAVIGATED_TO_CHATBOT_HISTORY: "NAVIGATED_TO_CHATBOT_HISTORY",
	NAVIGATED_TO_MANAGE_CLIENTS: "NAVIGATED_TO_MANAGE_CLIENTS",
	NAVIGATED_TO_MANAGE_VENDORS: "NAVIGATED_TO_MANAGE_VENDORS",
	NAVIGATED_TO_MANAGE_RECRUITERS_NETWORK: "NAVIGATED_TO_MANAGE_RECRUITERS_NETWORK"
};
/* Code end. Istiyak using AI Agent. August 21, 2026 */

/* Added the following code for Istiyak using AI Agent. August 24, 2026. Code Start */
/**
 * Recruiter Performance report APIs.
 * Backend compares created_at >= startDate AND created_at < endDate (endDate is exclusive).
 * Date params use "yyyy-MM-dd HH:mm:ss".
 */
export const RECRUITERS_REPORT_URL = API_URL + "/api/commons/dashboard/recruiters-report";
export const RECRUITERS_REPORT_HOURLY_URL = API_URL + "/api/commons/dashboard/recruiters-report/hourly";
export const RECRUITERS_REPORT_ACTIVITY_DETAILS_URL = API_URL + "/api/commons/dashboard/recruiters-report/activity-details";
/* Added the following code for Istiyak using AI Agent. August 25, 2026. Code Start */
export const RECRUITERS_REPORT_ACTIVITY_SEARCH_URL = API_URL + "/api/commons/dashboard/recruiters-report/activity-search";
export const RECRUITERS_REPORT_ACTIONS_URL = API_URL + "/api/commons/dashboard/recruiters-report/actions";
/* Code end. Istiyak using AI Agent. August 25, 2026 */
/* Code end. Istiyak using AI Agent. August 24, 2026 */

/* Added the following code for Istiyak using AI Agent. October 22, 2026. Code Start */
/**
 * Sourcing Performance logs.
 * GET returns ApiResponseDto; the run hierarchy is read from the data payload.
 */
export const SOURCING_LOGS_URL = API_URL + "/api/commons/dashboard/sourcing-logs";
/* Code end. Istiyak using AI Agent. October 22, 2026 */

/* Added the following code for Istiyak using AI Agent. October 22, 2026. Code Start */
/**
 * Sourcing configuration.
 * GET returns ApiResponseDto whose data is TableSourcingConfiguration.
 * POST /update saves that entity. The client always sends id = 1.
 */
export const SOURCING_CONFIG_URL = API_URL + "/api/commons/dashboard/sourcing-config";
export const SOURCING_CONFIG_UPDATE_URL = API_URL + "/api/commons/dashboard/sourcing-config/update";
/* Code end. Istiyak using AI Agent. October 22, 2026 */

// export const API_URL = "http://192.168.43.69:8080"

//refreshtoken
export const REFRESHTOKEN_URL = API_URL + "/api/auth/request/token";
// export const RELOADtOKEN_URL = API_URL + "/api/auth/request/token"

// Added this code for  POW-102. Khushi. April 10 2023.. Code Start /
//automation api
export const AUTOMATION_CHECK = API_URL + "/api/automation/check ";
export const AUTOMATION_CLIENTS = API_URL + "/api/automation/clients ";
export const AUTOMATION_START = API_URL + "/api/automation/start";
export const USERCOUNT_DETAILS = API_URL + "/api/automation/usercountDetails";
/* Added the following code for POW-920.Istiyak using AI Agent. September 7 2026. Code Start */
/** Admin-only automation APIs: operate on a recruiter username instead of the authenticated user. */
export const AUTOMATION_RECRUITERS_ALL = API_URL + "/api/automation/recruiters/all";
export const USERCOUNT_DETAILS_ALL = API_URL + "/api/automation/usercountDetails/all";
export const AUTOMATION_STATUS_ALL = API_URL + "/api/automation/status/all";
export const AUTOMATION_UPDATE_ALL = API_URL + "/api/automation/update/all";
export const AUTOMATION_STOP_ALL = API_URL + "/api/automation/stop/all";
export const RUNLOGDETAILS_ALL_URL = API_URL + "/api/automation/getDetails/all";
export const JOB_CANDIDATE_ASSIGNMENTS_ALL = API_URL + "/api/automation/getJobCandidateAssignments/all";
export const UPDATE_JOB_CANDIDATE_ASSIGNMENTS_ALL = API_URL + "/api/automation/updateJobCandidateAssignments/all";
/* Code end. Istiyak using AI Agent. September 7 2026 */
export const UPDATE_CANDIDATE_UPLOADS = API_URL + "/api/automation/updatecandidateUpload?updatecandidateUpload=";
export const UPDATE_TIME = API_URL + "/api/automation/updateTime?time=";
export const UPDATE_JOB_UPLOADS = API_URL + "/api/automation/updateJobUpload?jobUpload=";
export const UPDATE_DAILY = API_URL + "/api/automation/updateRunType?runType=";
export const UPDATE_WEEKLY_VALUES = API_URL + "/api/automation/updateWeekly?weekly=";
// Khushi. April 10 2023. Code End /
// Added this code for  POW-102. Khushi. April 15 2023.. Code Start /
export const AUTOMATION_UPDATE = API_URL + "/api/automation/update ";
// Added this code for  POW-102. Anand. August 09 2023.. Code Start /
export const AUTOMATION_STOP = API_URL + "/api/automation/stop ";
export const AUTOMATION_STATUS = API_URL + "/api/automation/status ";

export const GET_BEST_RESUMES_URL = API_URL + "/api/job/get_best_resumes";

// Added this code for  POW-102. Anand. August 09 2023.. Code End /
// Khushi. April 15 2023. Code End /
// Added this code for  POW-102. Khushi. May 17 2023.. Code Start /
export const AUTOMATION_SSE = API_URL + "/api/automation/ ";
// Khushi. May 17 2023. Code End /
//dev
export const LOGIN_URL = API_URL + "/api/auth";
export const PAGEASSIGN_URL = API_URL + "/api/auth/get/page/permission";
export const FORGOT_URL = API_URL + "/api/auth/forgot";
//business units
export const BUSINESSUNITLIST_URL = API_URL + "/api/business-unit/search";
export const BUSINESSUNITCREATE_URL = API_URL + "/api/business-unit/create";
export const BUSINESSUNITEDIT_URL = API_URL + "/api/business-unit/edit";
export const BUSINESSSTATUS_URL = API_URL + "/api/business-unit/active";

/*Added this code for POW-547. Istiyak. 07th August.*/
export const BUSINESSUNITDASHBOARD_URL = API_URL + "/api/business-unit/user/search";

//function
export const FUNCTIONS_GET_URL = API_URL + "/api/auth/functions/search";

// profile business
export const PROFILE_BUSINESS_URL = API_URL + "/api/auth/business/plan";

export const DEFAULT_PAGE_URL = API_URL + "/api/auth/user/default-page";

// admin sort
//candidate job status
export const CANDIDATEJOBLIST_URL = API_URL + "/api/cs/search";
export const CANDIDATEJOBCREATE_URL = API_URL + "/api/cs/create";
export const CANDIDATEJOBEDIT_URL = API_URL + "/api/cs/edit";
export const CANDIDATEJOBSTATUS_URL = API_URL + "/api/cs/active";

//vendors details 
export const VENDOR_DETAILS =API_URL+ "/api/manager-details/getVendorDetails";

//client job status
export const CLIENTJOBLIST_URL = API_URL + "/api/cjs/search";
export const CLIENTJOBCREATE_URL = API_URL + "/api/cjs/create";
export const CLIENTJOBEDIT_URL = API_URL + "/api/cjs/edit";
export const CLIENTJOBSTATUS_URL = API_URL + "/api/cjs/active";
// Added this code for  POW-20. Prasanna. August 25 2022.. Code Start
//Manager details
export const MANAGERDETAILSLIST_URL = API_URL + "/api/manager-details/search";
export const MANAGERDETAILSCREATE_URL = API_URL + "/api/manager-details/create";
export const MANAGERDETAILSSEARCH_URL = API_URL + "/api/manager-details/search";
export const MANAGERDETAILSEDIT_URL = API_URL + "/api/manager-details/edit";
export const MANAGERDETAILSSTATUS_URL = API_URL + "/api/manager-details/search";
// Prasanna. August 25 2022. Code End
//workauthorization st
export const WORKAUTHORIZATIONLIST_URL = API_URL + "/api/wa/search";
export const WORKAUTHORIZATIONCREATE_URL = API_URL + "/api/wa/create";
export const WORKAUTHORIZATIONEDIT_URL = API_URL + "/api/wa/edit";
export const WORKAUTHORIZATIONSTATUS_URL = API_URL + "/api/wa/active";
//chatbot
export const CHATBOTLIST_URL = API_URL + "/api/cb/search";
export const CHATBOTCREATE_URL = API_URL + "/api/cb/create";
export const CHATBOTEDIT_URL = API_URL + "/api/cb/edit";
export const CHATBOTSTATUS_URL = API_URL + "/api/cb/active";
//sourcename
export const SOURCENAMESLIST_URL = API_URL + "/api/sn/search";
export const SOURCENAMESCREATE_URL = API_URL + "/api/sn/create";
export const SOURCENAMESEDIT_URL = API_URL + "/api/sn/edit";
export const SOURCENAMESSTATUS_URL = API_URL + "/api/sn/active";

//employment types
export const EMPLOYMENTTYPESLIST_URL =
  API_URL + "/api/job/employment/getEmploymentDetails";
export const EMPLOYMENTTYPESCREATE_URL =
  API_URL + "/api/job/employment/add/employmentType";
export const EMPLOYMENTTYPESEDIT_URL =
  API_URL + "/api/job/employment/update/employmentType";
export const EMPLOYMENTTYPESSTATUS_URL =
  API_URL + "/api/job/employment/update/status";
export const EMPLOYMENTTYPESNAMELIST_URL =
  API_URL + "/api/job/employment/getEmploymentName";

//manageuser
export const MANAGEUSERLIST_URL = API_URL + "/api/auth/user/search";
export const MANAGEUSERSTATUS_URL = API_URL + "/api/auth/user/active";
export const MANAGEUSERCREATE_URL = API_URL + "/api/auth/user/register";
export const MANAGEUSEREDIT_URL = API_URL + "/api/auth/user/edit";
export const MANAGEUSEREDITBYID_URL = API_URL + "/api/auth/single/user/search";


// managesecurityrole
export const MANAGESECURITYCREATE_URL =
API_URL + "/api/auth/add/page/permission";
export const MANAGESECURITYEDIT_URL =
API_URL + "/api/auth/edit/page/permission";
export const PAGELIST_URL = API_URL + "/api/auth/pages/list";
export const PERMISSION_URL = API_URL + "/api/auth/get/role/permission";
export const MANAGESECURITYROLESEARH_URL =
  API_URL + "/api/auth/user/role/search";
export const ROLELIST_URL = API_URL  + "/api/auth/roles/list";
export const DELETEROLE_URL = API_URL  + "/api/auth/delete/role";

//recruiter dashboard
//upload job
// export const UPLOADFILE_URL = API_URL + "/api/job/description/upload"
export const UPLOADFILE_URL = API_URL + "/api/job/dx/description/upload";
export const GOTOJOBDETAILS_URL = API_URL + "/api/job/details/redirect";
/*Added this code for  POW-515. Dharmateja. June 10 2023.. Code Start*/
export const GOTOMANAGEJOBREDIRECT_URL = API_URL + "/api/job/details/redirect/notsubmitcand";
/*Dharmateja. June 10 2023.. Code End*/
//match history
export const MATCHHISTORYSEARCH_URL =
  API_URL + "/api/results/match/history/search";
// export const MATCHRESULTS_URL = API_URL + "/api/job/view/matching/candidates"
export const MATCHRESULTS_URL =
  API_URL + "/api/job/dx/match/history/redirect/results";
//chatbot history
export const CHATBOTSEARCH_URL = API_URL + "/api/results/chatbot/search";
export const VIEWCHATBOT_URL = API_URL + "/api/results/chatbot/history";
export const BOTLIST_URL = API_URL + "/api/cb/activetypes";

//upload job details
export const UPLOADJOBDETAILS_URL = API_URL + "/api/job/description/update";
// export const UPLOADJOBDETAILS_URL = API_URL + "/api/job/dx/description/update"
export const UPLOADSEARCH_URL = API_URL + "/api/job/search/candidates";
export const UPLOADWORKAUTH_URL = API_URL + "/api/wa/activestatuses";
export const ATTACHMENTEDITURL = API_URL + "/api/job/dx/candidates/attachment";
export const UPLOADCLIENTJOB_URL = API_URL + "/api/cjs/activestatuses";
export const UPLOADGRABER_URL = API_URL + "/api/job/grabber/info ";
/* Added this code for  POW-431. Prasanna. November 23 2022.. Code Start */
export const UPLOADHISTORY_URL = API_URL +"/api/job/manual/jobsinfo";
/* Prasanna. November 23 2022. Code End */
// export const GRABERSEND_URL =API_URL + "/api/job/dx/grabber/upload?grabberFilePath=https://power-recruit.s3-us-east-2.amazonaws.com/JD/2020-09-28/Covendis/55341/1601279674.docx"
export const GRABERSEND_URL = API_URL + "/api/job/dx/grabber/upload";

//candidate search
// export const RESUMELINK_URL = API_URL + '/api/job/candidate'
export const RESUMELINK_URL = API_URL + "/api/job/dx/candidate/initiate/resume";
// export const RESUMEVIEWLINK_URL = API_URL + '/api/job/dx/candidate/resume/data'
export const RESUMEVIEWLINK_URL = API_URL + "/api/job/dx/jobboard/view/resume";
export const DICERESUMEVIEWLINK_URL = API_URL + "/api/job/dice/resume"
export const DICE_RESUME_UPDATE_URL = API_URL + "/api/job/dice/resume/update";
// export const JOBSEARCH_URL = API_URL + '/api/job/search/candidates'
export const INITIATESEARCH_URL =
  API_URL + "/api/job/dx/candidate/initiate/search";
// export const JOBSEARCH_URL = API_URL + '/api/job/dx/candidate/search/results'
export const JOBSEARCH_URL = API_URL + "/api/job/search/candidates";
// export const RUNMATCHING_URL = API_URL + '/api/job/run/matching/candidates'
export const RUNMATCHING_URL = API_URL + "/api/job/run/matching";
export const GET_SAVEDRUN_MATCHING_DETAILS_URL = API_URL + "/api/job/saved/run/matching";
/* Added the following code for POW-877.Dharma Teja using AI Agent. June 22, 2026. Code Start */
export const GET_CANDIDATE_MATCH_HISTORY_URL = API_URL + "/api/job/matching/candidate/history";
/* Code end. Dharma Teja using AI Agent. June 22, 2026 */
export const RUN_JOB_RESUME_MATCH_URL = API_URL + "/api/job/run/match/job-resume";
/* Added the following code for POW-910.Harsha using AI Agent. September 9, 2026. Code Start */
export const LINK_RESUME_JOB_MATCH_CANDIDATE_URL = API_URL + "/api/job/run/match/job-resume/link-candidate";
/* Code end. Harsha using AI Agent. September 9, 2026 */
export const JOB_RESUME_ASSOCIATION_VALID_URL = API_URL + "/api/job/job-resume/association/valid";
// export const UPLOADSOVREN_URL = API_URL + '/api/job/upload/candidates'
export const UPLOADSOVREN_URL =
  API_URL + "/api/job/dx/upload/candidates/other/sources";
export const UPLOADSOVRENSELECTED_URL =
  API_URL + "/api/job/upload/candidates/all";
export const JOBDESCRIPTION_URL = API_URL + "/api/job/description/info";

//match results
export const FILTERBY_URL = API_URL + "/api/job/run/matching/sort";
// export const VIEWRESUMES_URL = API_URL + '/api/results/match/resume'
// export const VIEWRESUMES_URL = API_URL + '/api/job/dx/matched/resume'
export const VIEWRESUMES_URL = API_URL + "/api/job/dx/matched/resume";
export const SENDBOT_URL = API_URL + "/api/results/sendbot";
/* Added the following code for POW-776.Istiyak Khan using AI Agent. March 2, 2026. Code Start */
export const SEND_AI_CALLER_URL = API_URL + "/api/results/send/ai-caller";
/* Commenting the following code for POW-776.Istiyak Khan using AI Agent. March 2, 2026. Comment Start */
// export const CALL_HISTORY_URL = API_URL + "/api/results/calls/history";
/* Commenting end. Istiyak Khan using AI Agent. March 2, 2026 */
/* Code end. Istiyak Khan using AI Agent. March 2, 2026 */
export const SENDEMAIL_URL = API_URL + "/api/results/chatbot/send/mail";
export const SENDJOBEMAIL_URL = API_URL + "/api/results/network/send/mail";
export const SENDSMS_URL = API_URL + "/api/results/chatbot/send/sms";
export const GETJOBGRABBER_URL = API_URL + "/api/grabber/run/old"; //get jobgrabber
export const SENDCLIENTFORMATTEDRESUME_URL =
  API_URL + "/api/results/update/resume";
export const SOURCETYPE_URL = API_URL + "/api/sn/activesources";
export const CLIENTRESUMEFORMAT_URL = API_URL + "/api/results/resumeformat";
export const MIGRATE_URL = API_URL + "/api/job/dx/run/migrate/candidates";
export const JOBDETAILSKIPSEARCH_URL = API_URL + "/api/job/dx/skip/search";
export const MATCHSUBMIT_URL = API_URL + "/api/candidate/status/submit";
export const CHECK_SUBMIT_STATUS_URL = API_URL + "/api/candidate/check/submit/status";
/* Added the following code for POW-CLIENT-SUBMIT.Istiyak using AI Agent. June 5, 2026. Code Start */
export const CLIENT_SUBMIT_URL = API_URL + "/api/candidate/client-submit";
export const CLIENT_SUBMIT_STATUS_URL = API_URL + "/api/candidate/client-submit/status";
/* Code end. Istiyak using AI Agent. June 5, 2026 */
/* Added the following code for POW-793.Dharma using AI Agent. February 27, 2026. Code Start */
export const VALIDATE_RESUME_SKILLS_URL = API_URL + "/api/job/validate/resume/skills";
/* Code end. Dharma using AI Agent. February 27, 2026 */
/* Added the following code for POW-804.Solomon using AI Agent. June 24, 2026. Code Start */
export const AI_GENERATE_RESUME_URL = API_URL + "/api/job/ai/generate/resume";
/* Code end. Solomon using AI Agent. June 24, 2026 */
export const BACKTO_CANDIDATE_URL = API_URL + "/api/job/redirect/back";
export const PORTAL_QUESTIONS_URL = API_URL + "/api/job/get/submission/details";

// Manage job
export const MANAGEJOBSEARCH_URL = API_URL + "/api/candidate/job/search";
export const MANAGEJOBLIST_URL = API_URL + "/api/candidate/list";
export const MANAGEJOBDETAILS_URL = API_URL + "/api/candidate/job/details";
export const DICEJOBPOST_URL = API_URL + "/api/job/postJobOnDice";
export const MANAGEJOBASSIGN_URL = API_URL + "/api/candidate/job-assign";
export const SAVE_CANDIDATE_NOTE_URL = API_URL + "/api/candidate/save/candidate/note";
export const GET_CANDIDATE_NOTE_URL = API_URL + "/api/candidate/get/candidate/note";
/* Added the following code for POW-779.Dharma using AI Agent. February 28, 2026. Code Start */
export const SAVE_JOB_NOTE_URL = API_URL + "/api/candidate/save/job/note";
export const GET_JOB_NOTE_URL = API_URL + "/api/candidate/get/job/note";
/* Code end. Dharma using AI Agent. February 28, 2026 */
/* Added the following code for POW-869.Dharma using AI Agent. June 9, 2026. Code Start */
export const UPDATE_SUBMISSION_DEADLINE_URL = API_URL + "/api/candidate/job/submission-deadline/update";
/* Code end. Dharma using AI Agent. June 9, 2026 */
/* Added the following code for No Jira Ticket.Harsha using AI Agent. November 3, 2026. Code Start */
export const GET_SUBMISSION_DEADLINE_URL = API_URL + "/api/candidate/job/submission-deadline";
/* Code end. Harsha using AI Agent. November 3, 2026 */
/* Added the following code for POW-885.Dharma using AI Agent. July 22, 2026. Code Start */
/* QA nginx routes /api/results/* to backend; /api/vitelglobal/* returned React index.html (200 + HTML) */
export const VITELGLOBAL_RECORDINGS_URL = API_URL + "/api/results/vitelglobal/recordings";
export const VITELGLOBAL_RECORDING_STREAM_URL = API_URL + "/api/results/vitelglobal/recording/";
/* Code end. Dharma using AI Agent. July 22, 2026 */
/* Added the following code for POW-885.Dharma using AI Agent. July 2, 2026. Code Start */
export const REFRESH_VMS_OTHER_SUBMISSIONS_URL = API_URL + "/api/candidate/job/vms-other-submissions/refresh";
/* Code end. Dharma using AI Agent. July 2, 2026 */
export const GET_VIEWS_URL = API_URL + "/api/job/get/views";
export const GET_JOB_CANDIDATES_URL = API_URL + "/api/candidate/jobs/candidates";
// Manage Candidate
export const MANAGECANDIDATESEARCH_URL = API_URL + "/api/candidate/search";
export const MANAGECANDIDATESTATUS_URL = API_URL + "/api/cs/activestatuses";
export const MANAGECANDIDATEJOBLIST_URL = API_URL + "/api/candidate/job/list";
export const MANAGECANDIDATESKILLSET_URL = API_URL + "/api/candidate/details";
export const MANAGECANDIDATEDETAILS_URL = API_URL + "/api/candidate/details";
export const MANAGECANDIDATEVIEWSMS_URL = API_URL + "/api/results/sms/history";
export const MANAGECANDIDATEVIEWEMAIL_URL =
  API_URL + "/api/results/email/history";
export const MANAGECANDIDATEUPDATE_URL =
  API_URL + "/api/candidate/details/update";
export const CREATEPOSITIONHISTORY_URL =
  API_URL + "/api/candidate/emphistory/create";
export const CREATESKILLSET_URL = API_URL + "/api/candidate/skillset/create";
/* Added this code for  POW-377. Prasanna. November 28 2023.. Code Start */
export const CREATECANDIDATEPREF_URL = API_URL + "/api/candidate/candidatepref/create";
/* Prasanna. November 28 2023. Code End */
export const VIEWCONTACTINFO_URL =
  API_URL + "/api/candidate/communication/history";
//Email Attachment
export const SENDATTACHMENT_URL =
  API_URL + "/file/uploadMultipleFiles";

// Manage consultant

export const MANAGECONSULTANTSEARCH_URL =
  API_URL + "/api/candidate/to/consultant/search";
export const MANAGECONSULTANTSTATUS_URL =
  API_URL + "/api/candidate/to/consultant/active-inactive";
export const MANAGECONSULTANTUPDATE_URL =
  API_URL + "/api/candidate/to/consultant/update";
export const MANAGECONSULTANTADD_URL =
  API_URL + "/api/candidate/consultant/create";
//Manage Consultant Details
export const MANAGECONSULTANTDetails_URL =
  API_URL + "/api/candidate/to/consultant/getConsultantInfoById";
//Manage Consultant Update Personal Details
export const MANAGECONSULTANTPERSONALDERAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/updatePersonalDetailsByConsultantInfoId";
//Manage Consultant Update Skills Details
export const MANAGECONSULTANTSkillsDERAILS_URL =
  API_URL + "/api/candidate/to/consultant/updateSkillsByConsultantInfoId";
//Manage Consultant Update Employment Details
export const MANAGECONSULTANTEMPLOYMENTDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/updateEmploymentDetailsByConsultantInfoId";
//Manage Consultant Project Details
export const MANAGECONSULTANTPROJECTDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/updateProjectDetailsByConsultantInfoId";
//Manage Consultant Project Timeline Details
export const MANAGECONSULTANTPROJECTTIMELINEDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/updateProjectTimelineByConsultantInfoId";
//Hourly Rates And Fees Details
export const MANAGECONSULTANTHOURLYRATEANDFEESDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/updateHourlyRatesAndFeesByConsultantInfoId";
//Prior Projects Details
export const MANAGECONSULTANTPRIORPROJECTSDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/updatePriorProjectsDetailsByConsultantInfoId";
//Weekly Occurring Numbers  Details
export const MANAGECONSULTANTWEEKLOCCURRINGNUMBERDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/updateWeeklyOccurringNumbersByConsultantInfoId";
//Prior Projects Add Details
export const MANAGECONSULTANTPRIORPROJECTSADDDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/createPriorProjectsDetailsByConsultantInfoId";
//Weekly Occurring Numbers Add Details
export const MANAGECONSULTANTWEEKLOCCURRINGNUMBERADDDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/createWeeklyOccurringNumbersByConsultantInfoId";
//Weekly Occurring Numbers Get Details
export const MANAGECONSULTANTWEEKLOCCURRINGNUMBERGETDETAILS_URL =
  API_URL + "/api/candidate/to/consultant/getWeeklyOccurringNumbers";
//Manager Add Details
export const MANAGECONSULTANTMANAGERDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/createManagerDetailsByConsultantInfoId";
//Manager Update Details
export const MANAGECONSULTANTMANAGERUPDATEDETAILS_URL =
  API_URL +
  "/api/candidate/to/consultant/updateManagerDetailsByConsultantInfoId";
//Manager Delete Details
export const MANAGECONSULTANTMANAGERDELETEDETAILS_URL =
  API_URL + "/api/candidate/to/consultant/deleteManagerDetailsById";

// teamlead
// Manage client
export const MANAGECLIENTSEARCH_URL = API_URL + "/api/job/client/search";
export const MANAGECLIENTCREATE_URL = API_URL + "/api/job/client/create";
export const MANAGECLIENTEDIT_URL = API_URL + "/api/job/client/edit";
/* Added this code for  POW-464. Prasanna. February 02 2023.. Code Start */
export const MANAGECLIENTDELETE_URL = API_URL + "/api/job/client/deleteById";
/* Prasanna. February 02 2023. Code End */

// Manage Vendor
export const MANAGEVENDORSEARCH_URL = API_URL + "/api/job/vendor/search";
export const MANAGEVENDORCREATE_URL = API_URL + "/api/job/vendor/create";
export const MANAGEVENDOREDIT_URL = API_URL + "/api/job/vendor/edit";

/* Added this code for  POW-521. Prasanna. August 07 2023.. Code Start */
// Manage VMS Passwords
export const MANAGEVMSPASSWORDSSEARCH_URL = API_URL + "/api/job/vmspassword/search";
export const MANAGEVMSPASSWORDSCREATE_URL = API_URL + "/api/job/vmspassword/create";
export const MANAGEVMSPASSWORDSEDIT_URL= API_URL + "/api/job/vmspassword/edit";
export const MANAGEVMSPASSWORDSDELETE_URL = API_URL + "/api/job/vmspassword/deleteById";
/* Prasanna. August 07 2023. Code End */

// Manage Recruiter Network
export const MANAGERECRUITERNETWORKSEARCH_URL =
  API_URL + "/api/job/network/search";
export const MANAGERECRUITERNETWORKCREATE_URL =
  API_URL + "/api/job/network/create";
export const MANAGERECRUITERNETWORKEDIT_URL = API_URL + "/api/job/network/edit";
/* Added this code for  POW-472. Dharmateja.  January 31 2023.. Code Start */
export const MANAGERECRUITERNETWORKDELETE_URL = API_URL + "/api/job/network/deleteById";
/* Dharmateja. January 31 2023. Code End */

//live
// export const LOGIN_URL =API_URL+"api/auth"
// export const FORGOT_URL = API_URL+"api/auth/forgot"

// //job status for local testing
// export const JOBLIST_URL = "http://localhost:8110" + "/api/jobstatuses/search"
// export const JOBCREATE_URL = "http://localhost:8110" + "/api/jobstatuses/create"
// export const JOBEDIT_URL = "http://localhost:8110" + "/api/jobstatuses/edit"
// export const JOBSTATUS_URL = "http://localhost:8110" + "/api/jobstatuses/active"
// export const UPLOADJOBSTATUS_URL = "http://localhost:8110" + '/api/jobstatuses/activestatuses'

//job status
export const JOBLIST_URL = API_URL + "/api/jobstatuses/search";
export const JOBCREATE_URL = API_URL + "/api/jobstatuses/create";
export const JOBEDIT_URL = API_URL + "/api/jobstatuses/edit";
export const JOBSTATUS_URL = API_URL + "/api/jobstatuses/active";
export const UPLOADJOBSTATUS_URL = API_URL + "/api/jobstatuses/activestatuses";

//analytics dashboard
export const DASHBOARD_DATA_URL = API_URL + "/api/commons/dashboard/data";
// Added this code for  POW-673. Prasanna. May 27 2025.. Code Start 
export const DASHBOARD_CALL_DATA_URL =API_URL +"/api/commons/dashboard/chatbot/schedules";
// Prasanna. May 27 2025. Code End 
// Added this code for  POW-102. Khushi. May 03 2023.. Code Start /
//Automation Dashboard
export const AUTOMATION_DATA_URL = API_URL+ "/api/commons/dashboard/automation/data";
/* Added the following code for POW-920.Istiyak using AI Agent. September 7 2026. Code Start */
export const AUTOMATION_DATA_ALL_URL = API_URL + "/api/commons/dashboard/automation/data/all";
/* Code end. Istiyak using AI Agent. September 7 2026 */
export const AUTOMATION_CALL_DATA_URL = API_URL + "/api/commons/dashboard/chatbot/schedules/autopr";
// Khushi. May 03 2023. Code End /
//dashboard expenses setup
export const GET_CLIENT_LIST_URL = API_URL + "/api/job/expenses/getClientList";
export const ADD_CLIENT_LIST_URL = API_URL + "/api/job/expenses/addClientFee";
export const GET_CLIENT_LIST_DATA_URL =
  API_URL + "/api/job/expenses/searchClient";
export const UPDATE_CLIENT_LIST_DATA_URL =
  API_URL + "/api/job/expenses/updateClientFee";

//Insurances  setup
export const ADD_INSURANCES_DATA_URL =
  API_URL + "/api/job/expenses/addInsurancesFactoring";
export const UPDATE_INSURANCES_DATA_URL =
  API_URL + "/api/job/expenses/updateInsurancesFactoring";
export const GET_INSURANCES_DATA_URL =
  API_URL + "/api/job/expenses/getInsurancesFactoring";

//VMS  setup
export const GET_VMS_CLIENT_DATA_URL =
  API_URL + "/api/job/expenses/getVmsFeeClientList";
export const GET_VMS_DATA_URL = API_URL + "/api/job/expenses/getVmsFeeList";
export const GET_VMS_Table_DATA_URL =
  API_URL + "/api/job/expenses/searchVmsFee";
export const ADD_VMS_Table_DATA_URL = API_URL + "/api/job/expenses/addVmsFee";
export const UPDATE_Table_DATA_URL = API_URL + "/api/job/expenses/updateVmsFee";

//Job Board  setup
export const ADD_JOB_BOARD_DATA_URL = API_URL + "/api/job/expenses/addJobBoard";
export const DELETE_JOB_BOARD_DATA_URL =
  API_URL + "/api/job/expenses/deleteJobBoardById";
export const UPDATE_JOB_BOARD_DATA_URL =
  API_URL + "/api/job/expenses/updateJobBoard";
export const GET_JOB_BOARD_DATA_URL =
  API_URL + "/api/job/expenses/getAllJobBoard";

//

//Dashboard Job Data//

export const GETALLDATA = API_URL + "/api/commons/dashboard/data";
/* Commenting the following code for POW-855.Dharma using AI Agent. May 26, 2026. Comment Start */
/* export const GETALLJOBUNATTENDED =
API_URL + "/api/commons/dashboard/getAllJobUnattended";
export const GETALLJOBSCLIENTTOTALS =
API_URL + "/api/commons/dashboard/getAllJobsClientsTotals";

export const GETRECRUITERSUBMISSIONS =
API_URL + "/api/commons/dashboard/getRecruiterSubmissions"; 

export const ASSIGNEDRECRUITERSJOBS =
API_URL + "/api/commons/dashboard/assignedRecruitersJobs"; */
/* Commenting end. Dharma using AI Agent. May 26, 2026 */
/* Added the following code for POW-855.Dharma using AI Agent. May 26, 2026. Code Start */
export const GETALLJOBUNATTENDED =
API_URL + "/api/commons/dashboard/getAllJobUnattended";
export const GETALLJOBSCLIENTTOTALS =
 API_URL + "/api/commons/dashboard/getAllJobsClientsTotals";

export const GETRECRUITERSUBMISSIONS =
API_URL + "/api/commons/dashboard/getRecruiterSubmissions"; 

export const ASSIGNEDRECRUITERSJOBS =
API_URL + "/api/commons/dashboard/assignedRecruitersJobs";
/* Code end. Dharma using AI Agent. May 26, 2026 */

/* Added the following code for POW-889.Dharma using AI Agent. July 23, 2026. Code Start */
export const GETALLJOBPROCESSEDNOTSUBMITTED =
API_URL + "/api/commons/dashboard/getAllJobProcessedNotSubmitted";
/* Code end. Dharma using AI Agent. July 23, 2026 */

/* Added the following code for POW-947.Harsha using AI Agent. October 5, 2026. Code Start */
export const GETALLJOBNOTTOUCHED =
API_URL + "/api/commons/dashboard/getAllJobNotTouched";
/* Code end. Harsha using AI Agent. October 5, 2026 */

/* Added the following code for POW-891.Harsha using AI Agent. July 18, 2026. Code Start */
export const GETCANDIDATEREJECTIONS = API_URL + "/api/commons/dashboard/getCandidateRejections";
/* Code end. Harsha using AI Agent. July 18, 2026 */

// Automatic dahboard Run Log Table Data
export const RUNLOGDETAILS_URL = API_URL + "/api/automation/getDetails";

/* Added the following code for POW-798.Dharma using AI Agent. April 1, 2026. Code Start */
export const UPDATE_PROMPT_URL = API_URL + "/api/job/prompt";
export const LIST_PROMPTS_URL = API_URL + "/api/job/prompts";
/* Code end. Dharma using AI Agent. April 1, 2026 */

export const PROMPT_LOGS_URL = API_URL + "/api/job/prompt/logs";


/* Added the following code for POW-811.Harsha using AI Agent. May 19, 2026. Code Start */
export const HIDE_CANDIDATE_URL = API_URL + "/api/candidate/hide-candidate";
export const HIDE_JOB_URL = API_URL + "/api/candidate/hide-job";
export const HIDE_CHECK_URL = API_URL + "/api/candidate/hide/check";
/* Code end. Harsha using AI Agent. May 19, 2026 */

/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
export const OUTSIDE_CANDIDATE_SIGNUP_URL = API_URL + "/api/auth/outside-candidate/signup";
export const OUTSIDE_CANDIDATE_AUTH_URL = API_URL + "/api/auth/outside-candidate/login";
export const OUTSIDE_CANDIDATE_JOBS_SEARCH_URL = API_URL + "/api/candidate/outside/jobs/search";
/* Added the following code for POW-872.Harsha using AI Agent. July 29, 2026. Code Start */
export const OUTSIDE_CANDIDATE_JOBS_FILTER_OPTIONS_URL = API_URL + "/api/candidate/outside/jobs/filter-options";
/* Code end. Harsha using AI Agent. July 29, 2026 */
export const OUTSIDE_CANDIDATE_JOB_DETAIL_URL = API_URL + "/api/candidate/outside/jobs";
export const OUTSIDE_CANDIDATE_PROFILE_URL = API_URL + "/api/candidate/outside/profile";
export const OUTSIDE_CANDIDATE_JOB_SHARE_URL = API_URL + "/api/candidate/outside/jobs/share";
export const OUTSIDE_CANDIDATE_JOB_APPLY_URL = API_URL + "/api/candidate/outside/jobs";
export const OUTSIDE_CANDIDATE_RECRUITER_SEARCH_URL = API_URL + "/api/candidate/outside/recruiter/search";
export const OUTSIDE_CANDIDATE_RECRUITER_RESUME_URL = API_URL + "/api/candidate/outside/recruiter";
export const OUTSIDE_CANDIDATE_RECRUITER_JOB_MATCH_DOCUMENT_URL = API_URL + "/api/candidate/outside/recruiter/job/match-document";
/* Code end. Harsha using AI Agent. July 17, 2026 */

/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
export const PARTNER_SIGNUP_URL = API_URL + "/api/auth/partner/signup";
export const PARTNER_AUTH_URL = API_URL + "/api/auth/partner/login";
export const PARTNER_JOBS_SEARCH_URL = API_URL + "/api/partner/jobs/search";
export const PARTNER_JOBS_FILTER_OPTIONS_URL = API_URL + "/api/partner/jobs/filter-options";
export const PARTNER_JOB_DETAIL_URL = API_URL + "/api/partner/jobs";
export const PARTNER_PROFILE_URL = API_URL + "/api/partner/profile";
export const PARTNER_JOB_SUBMIT_URL = API_URL + "/api/partner/jobs";
export const PARTNER_JOB_SUBMISSION_COUNT_URL = API_URL + "/api/partner/jobs";
export const PARTNER_RECRUITER_SEARCH_URL = API_URL + "/api/partner/recruiter/search";
export const PARTNER_RECRUITER_RESUME_URL = API_URL + "/api/partner/recruiter";
/* Code end. Harsha using AI Agent. October 7, 2026 */

/* Added the following code for POW-950.Harsha using AI Agent. October 9, 2026. Code Start */
export const SIGNUP_USERS_PENDING_URL = API_URL + "/api/candidate/signup-users/pending";
/* Added the following code for No Ticket.Harsha using AI Agent. October 28, 2026. Code Start */
export const SIGNUP_USERS_APPROVED_URL = API_URL + "/api/candidate/signup-users/approved";
export const SIGNUP_USERS_DENIED_URL = API_URL + "/api/candidate/signup-users/denied";
/* Code end. Harsha using AI Agent. October 28, 2026 */
export const SIGNUP_USER_DETAIL_URL = API_URL + "/api/candidate/signup-users";
/* Code end. Harsha using AI Agent. October 9, 2026 */